 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"class-attendance~class-details~class-form~class-payments~class-search~class-session~class-students~c~c7c94133":"class-attendance~class-details~class-form~class-payments~class-search~class-session~class-students~c~c7c94133","class-attendance":"class-attendance","class-details~class-payments~class-session~class-students~class-task~create-class~message~payment-pr~dbe33a4f":"class-details~class-payments~class-session~class-students~class-task~create-class~message~payment-pr~dbe33a4f","class-details~view-class-list":"class-details~view-class-list","class-details":"class-details","class-payments":"class-payments","class-session~class-students":"class-session~class-students","class-session":"class-session","class-students":"class-students","class-task":"class-task","create-class~login~signup~student-details":"create-class~login~signup~student-details","create-class":"create-class","signup~student-details~view-class-list":"signup~student-details~view-class-list","student-details":"student-details","message":"message","payment-profile":"payment-profile","view-class-list":"view-class-list","student-class":"student-class","teacher-class":"teacher-class","transaction-records~view-students":"transaction-records~view-students","class-search~transaction-records":"class-search~transaction-records","transaction-records":"transaction-records","view-managers~view-students~view-teachers":"view-managers~view-students~view-teachers","view-students":"view-students","view-managers":"view-managers","view-teachers":"view-teachers","class-form":"class-form","class-search":"class-search","login":"login","signup":"signup","home":"home","file-resources":"file-resources","front":"front","reset":"reset"}[chunkId]||chunkId) + "." + {"class-attendance~class-details~class-form~class-payments~class-search~class-session~class-students~c~c7c94133":"f16ba32e","class-attendance":"67986480","class-details~class-payments~class-session~class-students~class-task~create-class~message~payment-pr~dbe33a4f":"9c4faeb2","class-details~view-class-list":"501fcc94","class-details":"ef4fee5b","class-payments":"fe653b4f","class-session~class-students":"94922d5c","class-session":"0ee5d412","class-students":"098e8972","class-task":"148d0562","create-class~login~signup~student-details":"0f863eb3","create-class":"7aa75c9a","signup~student-details~view-class-list":"00cf90ee","student-details":"b69d0292","message":"2b26b10a","payment-profile":"a40efea4","view-class-list":"e9af4c9f","student-class":"4330e6fb","teacher-class":"75ca6e1a","transaction-records~view-students":"6a1a413d","class-search~transaction-records":"f067097e","transaction-records":"df19110c","view-managers~view-students~view-teachers":"c12f543e","view-students":"eec12186","view-managers":"f3cb2d15","view-teachers":"231e506a","class-form":"9f84098e","class-search":"122ceacb","login":"6cd3cfcc","signup":"3e0a7986","home":"a7c48826","file-resources":"ef6369a2","front":"37664b6d","reset":"757a4630"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"class-attendance~class-details~class-form~class-payments~class-search~class-session~class-students~c~c7c94133":1,"class-attendance":1,"class-details~class-payments~class-session~class-students~class-task~create-class~message~payment-pr~dbe33a4f":1,"class-details~view-class-list":1,"class-details":1,"class-payments":1,"class-session~class-students":1,"class-session":1,"class-students":1,"class-task":1,"create-class~login~signup~student-details":1,"create-class":1,"signup~student-details~view-class-list":1,"student-details":1,"message":1,"payment-profile":1,"view-class-list":1,"student-class":1,"teacher-class":1,"transaction-records~view-students":1,"class-search~transaction-records":1,"transaction-records":1,"view-managers~view-students~view-teachers":1,"view-students":1,"view-teachers":1,"class-form":1,"class-search":1,"login":1,"signup":1,"home":1,"file-resources":1,"front":1,"reset":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"class-attendance~class-details~class-form~class-payments~class-search~class-session~class-students~c~c7c94133":"class-attendance~class-details~class-form~class-payments~class-search~class-session~class-students~c~c7c94133","class-attendance":"class-attendance","class-details~class-payments~class-session~class-students~class-task~create-class~message~payment-pr~dbe33a4f":"class-details~class-payments~class-session~class-students~class-task~create-class~message~payment-pr~dbe33a4f","class-details~view-class-list":"class-details~view-class-list","class-details":"class-details","class-payments":"class-payments","class-session~class-students":"class-session~class-students","class-session":"class-session","class-students":"class-students","class-task":"class-task","create-class~login~signup~student-details":"create-class~login~signup~student-details","create-class":"create-class","signup~student-details~view-class-list":"signup~student-details~view-class-list","student-details":"student-details","message":"message","payment-profile":"payment-profile","view-class-list":"view-class-list","student-class":"student-class","teacher-class":"teacher-class","transaction-records~view-students":"transaction-records~view-students","class-search~transaction-records":"class-search~transaction-records","transaction-records":"transaction-records","view-managers~view-students~view-teachers":"view-managers~view-students~view-teachers","view-students":"view-students","view-managers":"view-managers","view-teachers":"view-teachers","class-form":"class-form","class-search":"class-search","login":"login","signup":"signup","home":"home","file-resources":"file-resources","front":"front","reset":"reset"}[chunkId]||chunkId) + "." + {"class-attendance~class-details~class-form~class-payments~class-search~class-session~class-students~c~c7c94133":"701c2f35","class-attendance":"be894753","class-details~class-payments~class-session~class-students~class-task~create-class~message~payment-pr~dbe33a4f":"99169cbd","class-details~view-class-list":"6d2e63ba","class-details":"e096c882","class-payments":"f8e0a09d","class-session~class-students":"50bf9c44","class-session":"3c7f26c0","class-students":"62e9dc18","class-task":"2e71eb6e","create-class~login~signup~student-details":"d97bd714","create-class":"60017fc3","signup~student-details~view-class-list":"a97a69ab","student-details":"231564a2","message":"f570eba6","payment-profile":"8184f3de","view-class-list":"97f9c9be","student-class":"5963c513","teacher-class":"10902829","transaction-records~view-students":"8ba8905d","class-search~transaction-records":"363704ea","transaction-records":"c721615b","view-managers~view-students~view-teachers":"19c8a448","view-students":"5d806e00","view-managers":"31d6cfe0","view-teachers":"f811f00c","class-form":"f356b841","class-search":"459fad9d","login":"a1903b9e","signup":"6f4c34d6","home":"e9520a93","file-resources":"5a38f781","front":"c4eabc4a","reset":"3ee628fd"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
